import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Textarea } from '@fortem-monorepo/react-ui'

export interface DescriptionFormFieldProps {
  placeholder?: string
}

export const DescriptionFormField: React.FC<DescriptionFormFieldProps> = ({ placeholder }) => {
  const { control, register } = useFormContext<{ description: string }>()

  return (
    <FormField
      name="description"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Description</FormLabel>
              <FormError />
            </div>
            <Textarea
              {...register('description')}
              placeholder={placeholder ?? 'Enter a description...'}
            />
          </FormItem>
        )
      }}
    />
  )
}
